@import '../../global/accessibility.css';
@import 'src/global/train-colors';

.shopping-cart__content {
    color: #666;
    font-size: 16px;
    text-align: left;
    line-height: 1.2em;
    background: #fff;
    padding: 1px 15px;
    box-shadow: 0 10px 20px rgb(45 50 55 / 20%);

}

.shopping-cart__detail {
    position: relative;
    border-top: 1px solid black;
    padding: 20px 0;

    &:first-of-type {
        border: none;
        padding-top: 0;
    }
}

.shopping-cart__detail-header {
    display: flex;
    justify-content: space-between;
}

.shopping-cart__detail-title {
    margin: 0 0 15px;
    display: flex;
    align-items: center;

    .icon {
        margin-right: 10px;
    }
}

.shopping-cart__detail-remove {
    @include nj-button-secondary;

    position: absolute;
    right: 0;
    top: 20px;

    border: none;

    .shopping-cart__detail:first-of-type & {
        top: 0;
    }
}

.shopping-cart__detail-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
        margin-bottom: 10px;
    }
}

.shopping-cart__detail-highlight {
    display: block;
    font-weight: 700;
}

.shopping-cart__detail-highlight--indented {
    margin-left: 18px;
}

.shopping-cart__detail-connection {
    align-items: baseline;
}

.shopping-cart__detail-train {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin: 0 1rem;
}

.shopping-cart__insurance {
	.shopping-cart__detail-title {
		margin-bottom: 6px;
	}

	.shopping-cart__product {
		margin-top: 6px;
	}
}

.calendar {
    display: block;
    width: 40px;
    text-align: center;
    flex-shrink: 0;
    margin: 0 15px 10px 0;

    > * {
        display: block;
    }

    &__year {
        background: $tint-oebb;
        color: white;
        font-weight: bold;
        font-size: 0.8em;

    }

    &__body {
        border: 1px solid $color-grey-200;
    }

    &__day {
        font-weight: 700;
        display: block;
        text-align: center;
        font-size: 18px;
        padding-top: 2px;
    }

    &__month {
        font-size: .8em;
        text-align: center;
    }
}

.flex {
    display: flex;
}

.shopping-cart__product {
    display: grid;
    margin-top: 20px;

    .shopping-cart__product_ticket {
        grid-row: 2;
        grid-column: 1 / 3;
        font-size: smaller;
    }

    .shopping-cart__product_price {
        grid-row: 1;
        grid-column: 2;

        padding-left: 0.75em;
        white-space: nowrap;
        font-weight: bold;
        text-align: right;
    }
}

.shopping-cart__price {
    display: flex;
    justify-content: space-between;
    background: $tint-nightjet;
    color: #fff;
    padding: 10px 15px;
    font-weight: 700;
    position: sticky;
    bottom: 0;

}
